import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Country from "@/pcm/store/models/Country";
import Media from "@/pcm/store/models/Media";

export default class Category extends Model {
    static entity = 'categories';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            media_id: this.attr(null),
            name: this.string(''),
            description: this.string(null).nullable(),
            thumbnail_url: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),

            video_of_the_week: this.belongsTo(Media, 'media_id'),
        }
    }

    declare id: number;
    declare media_id: number;
    declare name: string;
    declare description: string;
    declare thumbnail_url: string;
}
